export default "__VITE_ASSET__CfRP24Xp__"